import { IFollowUpSurvey } from '@nkr/models/follow-up';
import { Label, Panel } from 'react-bootstrap';
import { PanelBodyWrapper, TableWrapper } from '../../styles';

const ProgressComplianceDetails = (props: { data: IFollowUpSurvey }) => {
    return (
        <Panel>
            <Panel.Heading>Progress/Compliance Details</Panel.Heading>
            <PanelBodyWrapper>
                <TableWrapper striped condensed>
                    <thead>
                        <tr>
                            <th>Progression</th>
                            <th>Compliance Due Date</th>
                            <th>Date Completed</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><strong>Survey Initiated</strong></td>
                            <td>--</td>
                            <td>{props.data.surveyInitiatedDateTime}</td>
                        </tr>
                        <tr>
                            <td><strong>Lab Option Selected</strong></td>
                            <td>--</td>
                            <td>{props.data.labChoiceDateTime}</td>
                        </tr>
                        <tr>
                            <td><strong>Lab Orders Uploaded</strong></td>
                            <td>--</td>
                            <td>{props.data.labOrdersUploadedDateTime}</td>
                        </tr>
                        <tr>
                            <td><strong>Survey Completed</strong></td>
                            <td>{props.data.complianceDueDate}</td>
                            <td>
                                {props.data.surveySubmittedDateTime != '' ?
                                    <Label bsStyle={props.data.isSurveyLate ? 'danger' : 'success'} style={{ width: '100%', display: 'inline-block' }}>{props.data.surveySubmittedDateTime}</Label>
                                    :
                                    <>{props.data.isSurveyLate ? <Label bsStyle='danger' style={{ width: '100%', display: 'inline-block' }}>INCOMPLETE - LATE</Label> : <>--</>}</>
                                }
                            </td>
                        </tr>
                        <tr>
                            <td><strong>Labs Completed</strong></td>
                            <td>{props.data.complianceDueDate}</td>
                            <td>
                                {props.data.followUpCompletedDateTime != '' ?
                                    <Label bsStyle={props.data.areLabsLate ? 'danger' : 'success'} style={{ width: '100%', display: 'inline-block' }}>{props.data.followUpCompletedDateTime}</Label>
                                    :
                                    <>{props.data.areLabsLate ? <Label bsStyle='danger' style={{ width: '100%', display: 'inline-block' }}>INCOMPLETE - LATE</Label> : <>--</>}</>
                                }
                            </td>
                        </tr>
                    </tbody>
                </TableWrapper>
            </PanelBodyWrapper>
        </Panel>
    )
}

export default ProgressComplianceDetails;